function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5195 5.89572C10.5195 7.66043 9.15953 9.10428 7.51953 9.10428C5.87953 9.10428 4.51953 7.66043 4.51953 5.89572V3.20856C4.51953 1.44385 5.87953 0 7.51953 0C9.15953 0 10.5195 1.44385 10.5195 3.20856V5.89572Z",
  fill: "#233780"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.75977 9.18448C5.75977 9.82619 6.51977 10.3877 7.47977 10.3877C8.43977 10.3877 9.19977 9.8663 9.19977 9.18448",
  fill: "#233780"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.51953 4.25152C4.51953 4.25152 5.87953 4.25152 7.11953 4.25152C8.87953 4.25152 10.1195 1.60446 10.1195 1.60446",
  fill: "#233780"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15 14.9998C14.36 11.4704 12.56 9.14417 7.48 9.14417C2.4 9.14417 0.64 11.4704 0 14.9998H15Z",
  fill: "#233780"
});

var SvgUserBlue = function SvgUserBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/userBlue.bc6ee566.svg";
export { ForwardRef as ReactComponent };